//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let OSS = require("ali-oss");

export default {
  name: "personal",

  data() {
    return {
      iconEdit: require("@/assets/image/icon/icon_edit_depict_1.png"),
      userInfo: {},
      system: "",
      iconAll: {
        iconAvatar: require("@/assets/image/icon/icon_avatar.png"),
        arrow: require("@/assets/image/icon/arrow.png")
      }
    };
  },
  mounted: function() {

  },
  methods: {
    //返回上一页
    onClickLeft(){
      this.$router.go(-1)
    },
    tirggerFile(event) {
      let files = event.target.files[0];

      this.LOGIN2.getSession().then(session => {
        let photoName = new Date().getTime() + session.userId;
        let photoType = files.name.split(".")[1];

        let name = "profile/" + photoName + "." + photoType;

        this.uploadImg(name, files);
      });
    },

    uploadImg(photoName, files) {
      this.$toast.text(this.$t("PERSONAL_LANG.uploadPortrait")); //顯示上傳中提示

      let postD = {
        fileName: photoName
      };

      this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.GETUPLOADTOKEN, postD, "POST")
        .then(res => {
          let client = new OSS({
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            bucket: "nowbook-picture",
            stsToken: res.securityToken,
            endpoint: "oss-cn-hongkong.aliyuncs.com"
          });

          var tempCheckpoint = "";

          try {
            client
              .multipartUpload(photoName, files, {
                progress: async function(p, checkpoint) {
                  // 记录断点, 如果关闭了浏览器，然后重新启动继续上传的话，是不行的，请参考上边对file对象的描述
                  tempCheckpoint = checkpoint;
                },
                mime: "image/jpeg"
              })
              .then(ossRes => {
                let imgUrl = ossRes.res.requestUrls[0].split("?uploadId")[0];

                let postD = {
                  headimgurl: imgUrl
                };
                this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.UPDATEINFO, postD, "POST")
                  .then(uploadRes => {
                    this.getData();
                    //native.hideLoading(); //隱藏loading
                    this.$toast.text(this.$t("PERSONAL_LANG.uploadPortraitSuccess"));
                  })
                  .catch(err => {
                    this.$toast.text(this.$t("PERSONAL_LANG.uploadPortraitFail") + "：" + err);
                  });
              })
              .catch(err => {
                // console.log(err);
                //native.hideLoading(); //隱藏loading
                this.$toast.text(this.$t("PERSONAL_LANG.uploadPhotoFail") + "：" + err);
              });
          } catch (error) {
            //native.hideLoading(); //隱藏loading
            this.$toast.text(this.$t("PERSONAL_LANG.err") + "：" + error);
          }
        })
        .catch(err => {
          //native.hideLoading(); //隱藏loading
          this.$toast.text(this.$t("PERSONAL_LANG.getPhotoFail") + "：" + err);
        });
    },

    getData() {
      this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.GETUSERINFO, {}, "POST")
        .then(res => {
          let obj = res;
          if (obj && obj.nickname) {
            if (obj.nickname.length > 10) {
              obj["showName"] = obj.nickname.substr(0, 10) + "...";
            } else {
              obj["showName"] = obj.nickname;
            }
          }

          this.userInfo = res;

        })
        .catch(err => {
          let res = err.response;
          // console.log(err);
          this.$toast.text(this.$t("PERSONAL_LANG.getUserDataFail"));
        });
    },
    gotopage(obj) {
      console.log(obj, 123456);
      this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
    }
  },
  created() {
    
  },
  mounted(){
    this.getData();
  }
};



// WEBPACK FOOTER //
// ./src/pages/me/personal.vue